<!-- eslint-disable vue/no-v-html -->
<template>
	<MainContainer :loading="pending" :fetched="!!data" :error="error" no-company-branding @try-again="refresh">
		<div class="flex w-full flex-col px-4 pb-24 pt-16 lg:px-6">
			<div class="flex w-full max-w-screen-xl flex-col self-center">
				<div class="flex items-center">
					<span class="text-natural-dark flex-grow text-3xl font-black">
						{{ $t("rules") }}
					</span>
				</div>
				<div class="mt-16 grid grid-cols-1 gap-x-12 gap-y-12 lg:grid-cols-12">
					<div class="col-span-1 flex flex-col lg:col-span-3">
						<div
							v-for="(page, i) in pages"
							:key="i"
							class="mb-4 line-clamp-1 rounded-md px-4 py-3 text-sm font-medium"
							:class="{
								'text-white bg-primary': i === state.currentPageIndex,
								'text-natural-dark ripple-bg-blue-grey-50 cursor-pointer': i !== state.currentPageIndex
							}"
							@click="state.currentPageIndex = i"
						>
							{{ page.title }}
						</div>
					</div>
					<div class="col-span-1 lg:col-span-9">
						<div
							class="flex flex-col"
							v-html="currentPage.text || $t('edit_this_text_from_the_admin_panel')"
						></div>
					</div>
				</div>
			</div>
		</div>
	</MainContainer>
</template>

<script lang="ts" setup>
const metaStore = useMetaStore()
const app = useNuxtApp()
const route = useRoute()

const state = reactive({
	fetched: false,
	currentPageIndex: Number(route.query.page) || 0,
	privacy: "",
	termsOfUse: "",
	financialRules: ""
})

const pages = computed(() => [
	{
		id: META_KEYS.META_TERMS_OF_USE,
		title: app.$i18n.t("terms_of_use"),
		text: data.value?.terms_of_use
	},
	{
		id: META_KEYS.META_FINANCIAL_RULES,
		title: app.$i18n.t("financial_rules"),
		text: data.value?.financial_rules
	},
	{
		id: META_KEYS.META_PRIVACY,
		title: app.$i18n.t("privacy"),
		text: data.value?.privacy
	}
])

const currentPage = computed(() => pages.value[state.currentPageIndex] || pages.value[0])

const { data, error, pending, refresh } = useLazyAsyncData(String(route.path), async () => {
	const r = await metaStore.getAllMetas({
		names: [META_KEYS.META_TERMS_OF_USE, META_KEYS.META_FINANCIAL_RULES, META_KEYS.META_PRIVACY].join(",")
	})
	return {
		privacy: r[META_KEYS.META_PRIVACY],
		terms_of_use: r[META_KEYS.META_TERMS_OF_USE],
		financial_rules: r[META_KEYS.META_FINANCIAL_RULES]
	}
})
</script>
